import React from 'react';
import { Link } from 'react-router-component';

module.exports = React.createClass({
  propTypes: {
    slug: React.PropTypes.string.isRequired,
    show: React.PropTypes.object.isRequired,
    image_path: React.PropTypes.string,
    name: React.PropTypes.string.isRequired,
    tagline: React.PropTypes.string.isRequired,
    country: React.PropTypes.object.isRequired,
    genres: React.PropTypes.array.isRequired,
  },

  getCountryAndGenre: function getCountryAndGenre() {
    // Trys to return a h2 element with country and genre. If neither is available returns nothing.
    if (this.props.country && this.props.country.name) {
      if (this.props.genres && this.props.genres.length && this.props.genres[0].name) {
        return `${ this.props.country.name } /\/ ${this.props.genres[0].name}`;
      }
      return this.props.country.name;
    } else if (this.props.genres && this.props.genres.length && this.props.genres[0].name) {
      return this.props.genres[0].name;
    }
    return '';
  },

  render: function render() {
    const link = `/shows/${this.props.show.slug}/${this.props.slug}`;
    let imgPath = `/static/files/placeholder.png`;
    if (this.props.image_path) {
      imgPath = `/static/files/${this.props.image_path}`;
    }
    return (
      <Link href={link} className="c-episode-thumbnail">
        <img className="c-episode-thumbnail__image" src={imgPath} alt={this.props.show.name}/>
        <div className="c-episode-thumbnail__overlay">
          <h1 className="c-episode-thumbnail__overlay__title">{ this.props.name }</h1>
          <h2 className="c-episode-thumbnail__overlay__title">{ this.getCountryAndGenre() }</h2>
          <p className="c-episode-thumbnail__overlay__title">{ this.props.tagline }</p>
        </div>
      </Link>
    );
  },
});
